import { useEffect } from "react";
import { register } from "@teamhanko/hanko-elements";

const hankoApi = process.env.BUN_PUBLIC_HANKO_API_URL  as string;

export function HankoProfile() {
  useEffect(() => {
    register(hankoApi).catch((error) => {
      console.error("Failed to register Hanko elements:", error);
    });
  }, []);

  return <hanko-profile />;
}
